import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { LeadForm } from 'sections/Benefits/components/LeadForm';
import styles from 'styles/pages/Benefits/BrandReliability/BrandReliability.module.scss';

const cn = classNames.bind(styles);

type SectionFormProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

const SectionForm: FC<SectionFormProps> = ({ pageTitle, formUrl, leadSubtype }: SectionFormProps): ReactElement => {
  return (
    <section className={cn('form')}>
      <div className={cn('container')}>
        <div className={cn('form__title-box')}>
          <h2 className={cn('form__title')}>
            Start Building Your Brand’s Reliability Today
          </h2>
          <p className={cn('form__title-description')}>
            Join the DFA network and set your business apart as a trusted, reliable freight partner.
          </p>
        </div>
        <div className={cn('form__content-box')}>
          <ul className={cn('form__content-list')}>
            <li className={cn('form__content-list-item')}>
              Boost Credibility: Instantly establish your brand as trustworthy with our prestigious global network.
            </li>
            <li className={cn('form__content-list-item')}>
              Win More Business: Stand out in a competitive market by showcasing your reliability.
            </li>
            <li className={cn('form__content-list-item')}>
              Exclusive Opportunities: Unlock collaborations with vetted freight forwarders across the globe.
            </li>
            <li className={cn('form__content-list-item')}>
              Reputation Management: Leverage our platform to protect and strengthen your brand identity.
            </li>
            <li className={cn('form__content-list-item')}>
              Expand Your Reach: Enter new markets confidently with a recognised seal of reliability.
            </li>
          </ul>
          <LeadForm
            pageTitle={pageTitle ?? ''}
            formUrl={formUrl ?? ''}
            leadSubtype={leadSubtype ?? ''}
            buttonText='Join DFA Now'
            formClassNames={{
              container: cn('lead-form'),
              formElements: cn('lead-form__form-elements'),
              buttons: cn('lead-form__buttons'),
              button: cn('lead-form__button'),
              preloader: cn('lead-form__preloader'),
            }}
            inputClassNames={{
              container: cn('input'),
              labelText: cn('input__label-text'),
              input: cn('input__input'),
            }}
            selectClassNames={{
              selectPanel: cn('phone__select-panel'),
              selectPanelPhone: cn('phone__select-panel--phone'),
              selectPanelNumber: cn('phone__select-panel-number--fill'),
              selectInput: cn('phone__select-input'),
              inputLabel: cn('phone__input-label'),
              input: cn('phone__input'),
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionForm;